export default __webpack_public_path__ + "static/media/about_us.d53f446a.svg";